import script from "./inquiry_end.vue?vue&type=script&setup=true&lang=ts"
export * from "./inquiry_end.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__